import { useSearchPageParams } from "@/hooks/useTableParams";
import type { PROJECT_TAB_KEYS } from "@/routes/company/routes.projects.constants";

/**
 * URL-backed search + page for one project-detail tab.
 *
 * All five tabs live on the same url behind `hTab`, so each table is
 * namespaced by its tab key — otherwise switching tabs would carry the
 * previous tab's search term and page number over.
 *
 * These tables have no filter panel, so there are no filter fields.
 */
export const useProjectTabParams = (tab: PROJECT_TAB_KEYS) =>
  useSearchPageParams(tab);
